"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinaryReadImpulse = void 0;
var BinaryReadImpulse = /** @class */ (function () {
    function BinaryReadImpulse(uri) {
        this.uri = uri;
    }
    return BinaryReadImpulse;
}());
exports.BinaryReadImpulse = BinaryReadImpulse;
//# sourceMappingURL=BinaryReadImpulse.js.map